export default "__VITE_PUBLIC_ASSET__a62b7c40__"